/* Saffroney design layer — small enhancements on top of the Hyper theme scripts. */
(function () {
  'use strict';

  /* Header: mirror the mobile drawer state on the toggle for screen readers. */
  document.addEventListener('click', function (event) {
    var toggle = document.querySelector('.sf-header__toggle');
    if (!toggle) return;
    if (event.target.closest('.sf-header__toggle')) {
      toggle.setAttribute('aria-expanded', 'true');
    } else if (event.target.closest('.close-box, .mm-fullscreen-bg')) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  /* Header: hide the cart badge when the count is 0 (count is updated by cart.api.js / footer-js). */
  function syncCountBadge(badge) {
    badge.classList.toggle('is-empty', parseInt(badge.textContent, 10) === 0 || badge.textContent.trim() === '');
  }
  document.querySelectorAll('.sf-header .bigcounter').forEach(function (badge) {
    syncCountBadge(badge);
    new MutationObserver(function () { syncCountBadge(badge); })
      .observe(badge, { childList: true, characterData: true, subtree: true });
  });

  /* Wishlist (signed-in customers only; one list per customer, see sfWishlistSave).
     Wishlist page (sections/wishlist.liquid). Hyper's wishlist.js keeps the saved product handles in
     localStorage "user_wishlist"; here we only read that list: show the saved cards (in saved order),
     drop a card as soon as its heart is clicked, and show the empty state when nothing is left. */
  function sfWishlistRead() {
    try {
      var list = JSON.parse(localStorage.getItem('user_wishlist') || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (handle, i) { return handle && list.indexOf(handle) === i; });
    } catch (e) {
      return [];
    }
  }
  function sfHideTooltips(scope) {
    scope.querySelectorAll('[data-bs-toggle="tooltip"], [aria-describedby^="tooltip"]').forEach(function (el) {
      var tip = window.bootstrap && bootstrap.Tooltip && bootstrap.Tooltip.getInstance(el);
      if (tip) tip.hide();
      var id = el.getAttribute('aria-describedby');
      var orphan = id && document.getElementById(id);
      if (orphan && orphan.classList.contains('tooltip')) orphan.remove();
    });
  }
  function sfWishlistRender() {
    var page = document.querySelector('[data-sf-wishlist]');
    if (!page) return;
    var grid = page.querySelector('[data-sf-wishlist-grid]');
    var empty = page.querySelector('[data-sf-wishlist-empty]');
    var saved = sfWishlistRead();
    var shown = 0;
    if (grid) {
      var items = {};
      var wasShown = [];
      grid.querySelectorAll('[data-sf-wishlist-item]').forEach(function (item) {
        items[item.getAttribute('data-sf-wishlist-item')] = item;
        if (!item.hidden) wasShown.push(item);
        item.hidden = true;
      });
      saved.forEach(function (handle) {
        var item = items[handle];
        if (!item) return;
        item.hidden = false;
        grid.appendChild(item); /* saved order */
        shown++;
      });
      /* A removed card disappears under the pointer, so its Bootstrap "Wishlist" tooltip never gets a
         mouseleave and would stay on screen: close it. */
      wasShown.forEach(function (item) {
        if (item.hidden) sfHideTooltips(item);
      });
      /* Products that no longer exist (all products are on this page): forget them. */
      if (grid.getAttribute('data-sf-wishlist-complete') === 'true') {
        var known = saved.filter(function (handle) { return items[handle]; });
        if (known.length !== saved.length) {
          saved = known;
          try { localStorage.setItem('user_wishlist', JSON.stringify(saved)); } catch (e) {}
          sfWishlistSave();
        }
      }
      grid.hidden = shown === 0;
    }
    if (empty) empty.hidden = shown !== 0;
    /* Keep Hyper's header counter in step with the real list. */
    try { localStorage.setItem('user_wishlist_count', String(saved.length)); } catch (e) {}
    document.querySelectorAll('.wishlist-counter').forEach(function (counter) { counter.textContent = saved.length; });
  }
  /* One list per signed-in customer: layout/theme.liquid loads "sf_wishlist_<customer id>" into
     "user_wishlist" before wishlist.js runs; every change is copied back here. */
  function sfWishlistSave() {
    if (!window.sfWishlistOwner) return;
    try { localStorage.setItem('sf_wishlist_' + window.sfWishlistOwner, JSON.stringify(sfWishlistRead())); } catch (e) {}
  }
  sfWishlistRender();
  document.addEventListener('DOMContentLoaded', sfWishlistRender);
  /* wishlist.js updates the list in its own click handler (bound on the button) and rewrites the button's
     inner HTML, so the click is caught in the capture phase (target still attached) and the list re-read after. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.wishlist-btn')) return;
    setTimeout(function () {
      sfWishlistSave();
      sfWishlistRender();
    }, 0);
  }, true);
  window.addEventListener('storage', function (event) {
    if (event.key === 'user_wishlist') sfWishlistRender();
  });

  /* Smile.io rewards (launcher button, open panel and the frames inside it): Smile draws everything in
     same-origin iframes with its own colours and fonts, so the Saffroney look is added inside each of them,
     again whenever Smile rebuilds one. Colours go through Smile's own CSS variables (set on every element so
     they win over Smile's inline values); headings use Newsreader, the rest Work Sans (the theme's Google
     Fonts link is loaded in each frame). The small "lite" launcher is a plain <button> with an inline colour. */
  var SMILE_CSS = [
    '*{--launcher-color:#9A3221!important;--button-base-colour:#B23C28!important;--button-hover-colour:#9A3221!important;',
    '--button-active-colour:#9A3221!important;--banner-base-colour:#B23C28!important;--banner-gradient-dark-colour:#9A3221!important;}',
    'body,.body-1,.caption,.heading,.text-input,button,input{font-family:"Work Sans",Arial,sans-serif!important;}',
    '.display,.header-primary,h1,h2{font-family:"Newsreader",Georgia,serif!important;font-weight:500!important;}',
    'a:not(.btn):not([class*="btn-"]){color:#B23C28!important;}',
    '.background-primary{background-color:#9A3221!important;}',
    /* Smile focuses the launcher again when the panel closes and rings it in the system "highlight" blue:
       no ring after a click; while Smile reports keyboard use (accessibility-nav-keyboard) a white one. */
    '.launcher-button:focus>*{box-shadow:none!important;}',
    '.accessibility-nav-keyboard .launcher-button:focus>*{box-shadow:inset 0 0 0 3px rgba(255,255,255,0.85)!important;}'
  ].join('');
  /* Smile sizes each launcher frame to its own measurement of the button, so anything wider (a border, the
     theme font) made the frame show scrollbars when tapped: the launchers never scroll, and the border is only
     recoloured, not added. */
  var SMILE_LAUNCHER_CSS = 'html,body{overflow:hidden!important;}';
  var SMILE_LITE_LAUNCHER_CSS = SMILE_LAUNCHER_CSS + 'button{background-color:#9A3221!important;border-color:#9A3221!important;color:#FFFFFF!important;}';
  function smileFontsHref() {
    var link = document.querySelector('link[href*="fonts.googleapis.com"][href*="Newsreader"]');
    return link ? link.href : '';
  }
  function styleSmileFrame(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; /* not same-origin: Smile's own look stays */ }
    if (!doc || !doc.head) return;
    if (!doc.getElementById('sf-smile-style')) {
      var fonts = smileFontsHref();
      if (fonts) {
        var link = doc.createElement('link');
        link.rel = 'stylesheet';
        link.href = fonts;
        doc.head.appendChild(link);
      }
      var style = doc.createElement('style');
      style.id = 'sf-smile-style';
      style.textContent = frame.id === 'smile-lite-launcher-frame' ? SMILE_LITE_LAUNCHER_CSS
        : frame.classList.contains('smile-launcher-frame') ? SMILE_CSS + SMILE_LAUNCHER_CSS : SMILE_CSS;
      doc.head.appendChild(style);
    }
    /* Smile's illustration icons come from its server in the colour named in the URL (?color=%236568FE,
       its purple): ask for the Saffroney red instead. White icons (the launcher bag) are left as they are. */
    doc.querySelectorAll('img[src*="platform.smile.io/images/"]').forEach(function (img) {
      var src = img.getAttribute('src');
      var match = /([?&]color=)(%23|#)([0-9a-f]{6})/i.exec(src);
      if (!match || /^(ffffff|b23c28)$/i.test(match[3])) return;
      img.setAttribute('src', src.replace(match[0], match[1] + '%23B23C28'));
    });
    /* frames inside the panel */
    doc.querySelectorAll('iframe').forEach(watchSmileFrame);
    if (!doc.sfSmileObserved && window.MutationObserver) {
      doc.sfSmileObserved = true;
      new MutationObserver(function () { styleSmileFrame(frame); }).observe(doc.documentElement, { childList: true, subtree: true });
    }
  }
  function watchSmileFrame(frame) {
    if (!frame.sfSmileWatched) {
      frame.sfSmileWatched = true;
      frame.addEventListener('load', function () { styleSmileFrame(frame); });
    }
    styleSmileFrame(frame);
  }
  function watchSmile() {
    document.querySelectorAll('[id^="smile-ui"] iframe, iframe#smile-lite-launcher-frame').forEach(watchSmileFrame);
  }
  if (window.MutationObserver) {
    new MutationObserver(watchSmile).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Klaviyo popup (styled in saffroney.css): while the form in Klaviyo still has the old Herati photo and the
     "No Thanks i'll pay extra" label, show the Saffroney photo and a plain "No thanks". Only those exact old
     values are replaced, so anything changed later in Klaviyo's form editor shows as set there. */
  var KLAVIYO_OLD_IMAGE = '9885fa28-9549-48ab-9a13-3d05e774061d';
  var KLAVIYO_OLD_DECLINE = /^\s*No Thanks i'll pay extra\s*$/i;
  function brandKlaviyoPopup(popup) {
    popup.querySelectorAll('img[src*="' + KLAVIYO_OLD_IMAGE + '"]').forEach(function (img) {
      if (window.sfKlaviyoPopupImage) {
        img.src = window.sfKlaviyoPopupImage;
        img.alt = '';
      }
    });
    popup.querySelectorAll('.klaviyo-form-button').forEach(function (button) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (KLAVIYO_OLD_DECLINE.test(node.nodeValue)) node.nodeValue = 'No thanks';
      }
    });
    /* Success step (the step without an email field): the old "$10.99 saved" wording becomes the 10% offer's
       message, and a "Start shopping" button is added when Klaviyo's step has no button. */
    var form = popup.querySelector('.klaviyo-form');
    if (!form || form.querySelector('input[type="email"]')) return;
    form.querySelectorAll('[id^="rich-text-"] p').forEach(function (p) {
      var text = p.textContent.replace(/\s+/g, ' ').trim();
      if (/You.ve saved \$10\.99 on your order/i.test(text)) p.textContent = 'You’re in!';
      else if (/^Your exclusive discount code has been sent to your email inbox\.?$/i.test(text)) p.textContent = 'Check your inbox. Your 10% off code is on its way.';
    });
    var column = form.firstElementChild;
    if (column && !form.querySelector('.klaviyo-form-button, .sf-klaviyo-shop')) {
      var link = document.createElement('a');
      link.className = 'sf-klaviyo-shop';
      link.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'collections/all';
      link.textContent = 'Start shopping';
      column.appendChild(link);
    }
  }
  /* Teaser tab: while it still has the old "$10.99" offer, show the current 10% offer. */
  var KLAVIYO_OLD_TEASER = /^\s*GET YOUR \$10\.99 OFF\s*$/i;
  function brandKlaviyoTeaser(teaser) {
    var walker = document.createTreeWalker(teaser, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (KLAVIYO_OLD_TEASER.test(node.nodeValue)) node.nodeValue = 'GET 10% OFF';
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(function () {
      document.querySelectorAll('[data-testid="POPUP"]').forEach(brandKlaviyoPopup);
      document.querySelectorAll('[class*="kl-teaser-"]').forEach(brandKlaviyoTeaser);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Footer newsletter (sections/sf-footer.liquid): the form still posts to Shopify (subscribed customer);
     when the section has a Klaviyo public key and list ID, the email is first added to that Klaviyo list
     through Klaviyo's public client API. The Shopify post reloads the page, which would cut the Klaviyo
     request off, so it waits for Klaviyo (at most 3 seconds) and is then sent again with requestSubmit,
     so Shopify's own submit handling (bot protection) still runs. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#sf-footer-newsletter');
    if (!form || !window.fetch || form.sfKlaviyoDone) return;
    var key = form.getAttribute('data-sf-klaviyo-key');
    var list = form.getAttribute('data-sf-klaviyo-list');
    var field = form.querySelector('input[type="email"]');
    var email = field ? field.value.trim() : '';
    if (!key || !list || !email || (field.checkValidity && !field.checkValidity())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');
    var subscribe = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer newsletter',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    }).catch(function () { /* the Shopify signup still goes through */ });
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 3000); });
    Promise.race([subscribe, timeout]).then(function () {
      form.sfKlaviyoDone = true;
      if (button) button.removeAttribute('aria-busy');
      if (form.requestSubmit) form.requestSubmit(button || undefined);
      else form.submit();
    });
  }, true);

  /* Sign in page: "Forgot password?" moves to the reset form's email field; "Cancel" returns to the login email. */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-sf-recover-link]')) {
      var recover = document.getElementById('RecoverEmail');
      if (!recover) return;
      event.preventDefault();
      recover.scrollIntoView({ block: 'center', behavior: 'smooth' });
      recover.focus({ preventScroll: true });
    } else if (event.target.closest('[data-sf-recover-cancel]')) {
      var login = document.getElementById('CustomerEmail');
      if (login) setTimeout(function () { login.focus(); }, 0);
    }
  });

  /* FAQ (sections/sf-faq.liquid): each question button opens/closes its own answer. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-sf-faqs-toggle]');
    if (!toggle) return;
    var answer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!answer) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    answer.hidden = !open;
    var item = toggle.closest('.sf-faqs__item');
    if (item) item.classList.toggle('is-open', open);
  });

  /* Contact form (sections/sf-contact.liquid): check required fields and the email before sending,
     show the message under the field, and stop a second click while the page is posting.
     Shopify still validates and shows its own errors / confirmation after the post. */
  function sfContactField(input) {
    var error = document.getElementById(input.id + '-error');
    var valid = input.checkValidity() && !(input.required && !input.value.trim());
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (error) error.hidden = valid;
    return valid;
  }
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-sf-contact-form]');
    if (!form) return;
    if (form.sfSending) {
      event.preventDefault();
      return;
    }
    var first = null;
    form.querySelectorAll('input[required], textarea[required], input[type="email"], input[type="tel"]').forEach(function (input) {
      if (!sfContactField(input) && !first) first = input;
    });
    if (first) {
      event.preventDefault();
      first.focus();
      return;
    }
    form.sfSending = true;
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');
  });
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-sf-contact-form] input, [data-sf-contact-form] textarea');
    if (input && input.getAttribute('aria-invalid') === 'true') sfContactField(input);
  });
  /* After Shopify's response, bring the confirmation / error message into view. */
  var sfContactStatus = document.querySelector('[data-sf-contact-status]');
  if (sfContactStatus) {
    sfContactStatus.scrollIntoView({ block: 'center' });
    sfContactStatus.focus({ preventScroll: true });
  }

  /* Collection "Sort by" custom dropdown (Hyper toggles .active on click): close it on an outside tap or
     Escape, and expose its state to screen readers. */
  function sfSortClose() {
    document.querySelectorAll('.product-short .short-title-lg.active, .product-short #select-wrap.active').forEach(function (el) {
      el.classList.remove('active');
    });
  }
  function sfSortSyncAria() {
    var toggle = document.querySelector('.product-short .short-title-lg');
    var list = document.getElementById('select-wrap');
    if (!toggle || !list) return;
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-controls', 'select-wrap');
    toggle.setAttribute('aria-expanded', list.classList.contains('active') ? 'true' : 'false');
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.product-short')) sfSortClose();
    setTimeout(sfSortSyncAria, 0);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.product-short #select-wrap.active')) {
      sfSortClose();
      sfSortSyncAria();
      var toggle = document.querySelector('.product-short .short-title-lg');
      if (toggle) toggle.focus();
    }
  });
  sfSortSyncAria();

  /* Collection page: the sidebar "Categories" links load the other collection without a full page reload.
     Swaps banner, title/image, categories, filters, sort label and product grid (the grid through Hyper's
     collection-sidebar.js, which also re-binds the card scripts); the toolbar keeps its listeners.
     Falls back to a normal page load if anything is missing. */
  var sfShopPath = window.location.pathname;
  function sfSwap(doc, selector, outer) {
    var next = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (!next || !current) return;
    if (outer) current.outerHTML = next.outerHTML;
    else current.innerHTML = next.innerHTML;
  }
  function sfShopLoad(url, push) {
    var shop = document.querySelector('.sf-shop');
    if (!shop || !window.fetch || typeof FacetFiltersForm === 'undefined') {
      window.location.href = url;
      return;
    }
    shop.classList.add('is-loading');
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('load failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('.sf-shop #ProductGridContainer') || !doc.querySelector('#FacetFiltersForm')) throw new Error('other layout');

        sfSwap(doc, '.sf-page-banner', true);
        sfSwap(doc, '.sf-shop .collection-img-wrap');
        sfSwap(doc, '.sf-shop .shop-sidebar.shop-collection', true);
        sfSwap(doc, 'facet-filters-form', true);
        sfSwap(doc, '#select-wrap');
        var sortTitles = doc.querySelectorAll('.product-short .sort-title');
        document.querySelectorAll('.product-short .sort-title').forEach(function (el, i) {
          if (sortTitles[i]) el.textContent = sortTitles[i].textContent;
        });
        var nextLinks = doc.querySelectorAll('.sf-header .main-menu li, .sf-header .main-menu a');
        var links = document.querySelectorAll('.sf-header .main-menu li, .sf-header .main-menu a');
        if (nextLinks.length === links.length) {
          links.forEach(function (el, i) { el.className = nextLinks[i].className; });
        }
        FacetFiltersForm.renderProductGridContainer(html);

        /* keep the grid / list view the shopper chose */
        var view = document.querySelector('.list-change-view.active');
        var wrap = document.querySelector('#ProductGridContainer .shop-product-wrap');
        if (view && wrap) {
          wrap.classList.remove('grid-1', 'grid-2', 'grid-3', 'grid-4');
          wrap.classList.add('grid-' + view.getAttribute('data-grid-view'));
        }

        var search = new URL(url, window.location.href).search.slice(1);
        if (push) history.pushState({ searchParams: search, sfCollection: true }, '', url);
        sfShopPath = window.location.pathname;
        document.title = doc.title;
        FacetFiltersForm.searchParamsPrev = search;
        FacetFiltersForm.filterData = [];
        if (window.Shopify) Shopify.queryParams = {};

        /* mobile: close the filter drawer to show the products */
        var drawer = document.querySelector('.filter-sidebar.active');
        if (drawer) {
          drawer.classList.remove('active');
          var overlay = document.querySelector('.mm-fullscreen-bg');
          if (overlay) overlay.classList.remove('active');
          document.body.classList.remove('hidden');
        }
        var top = shop.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 20, behavior: 'smooth' });
        shop.classList.remove('is-loading');
      })
      .catch(function () {
        window.location.href = url;
      });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.sf-shop .shop-sidebar.shop-collection a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
    event.preventDefault();
    var item = link.closest('li');
    if (item && item.classList.contains('active')) return;
    document.querySelectorAll('.sf-shop .shop-sidebar.shop-collection li').forEach(function (li) {
      var on = li === item;
      li.classList.toggle('active', on);
      var box = li.querySelector('input.cust-checkbox');
      if (box) box.checked = on;
    });
    sfShopLoad(link.href, true);
  });
  window.addEventListener('popstate', function (event) {
    if (!document.querySelector('.sf-shop') || window.location.pathname === sfShopPath) return;
    /* collection-sidebar.js also listens to popstate: mark the state as handled so it does not render too */
    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.searchParamsPrev = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
    }
    sfShopLoad(window.location.href, false);
  });

  /* Mini cart (Hyper .mini-cart drawer, snippets/mini-cart-drawer.liquid).
     - Open state is Hyper's `.mini-cart.show` + `.mm-fullscreen-bg.active`, so main.js (overlay click, the
       product page "Add to cart") and this file share it; side effects run from a class observer.
     - Every change re-renders the drawer from Shopify with the Section Rendering API (sections/sf-cart-drawer.liquid).
     - Lines are changed by line item key; requests run one at a time and only the latest one is rendered. */
  var CART_SECTION = 'sf-cart-drawer';
  var cartRequestId = 0;
  var cartPending = 0;
  var cartQueue = Promise.resolve();
  var cartLineTimers = {};
  var cartReturnFocus = null;
  var cartWasOpen = false;
  var cartRenderedAt = 0;
  var cartCloseTimer = null;

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function getCartDrawer() {
    return document.querySelector('[data-sf-cart]');
  }
  function cartIsOpen() {
    var drawer = getCartDrawer();
    return !!drawer && drawer.classList.contains('show');
  }
  function cartText(key, fallback) {
    var drawer = getCartDrawer();
    return (drawer && drawer.getAttribute('data-sf-text-' + key)) || fallback;
  }
  function cartLineSelector(key) {
    return '[data-sf-line="' + String(key).replace(/["\\]/g, '\\$&') + '"]';
  }
  /* Render a response only if no newer request was started and no +/- click is still waiting to be sent. */
  function cartShouldRender(id) {
    return id === cartRequestId && Object.keys(cartLineTimers).length === 0;
  }
  /* The cart is shown in up to two places, each a Shopify section re-rendered from the same responses:
     the mini cart (every page) and the cart page (sections/cart-template.liquid). */
  function cartViews() {
    var views = [];
    var drawer = getCartDrawer();
    if (drawer) views.push({ root: drawer, section: CART_SECTION, drawer: true });
    var page = document.querySelector('[data-sf-cart-page]');
    if (page && page.getAttribute('data-section-id')) views.push({ root: page, section: page.getAttribute('data-section-id'), drawer: false });
    return views;
  }
  function cartSectionIds() {
    return cartViews().map(function (view) { return view.section; }).join(',');
  }

  function openCart() {
    var drawer = getCartDrawer();
    var overlay = document.querySelector('.mm-fullscreen-bg');
    if (!drawer) return;
    drawer.classList.add('show');
    if (overlay) overlay.classList.add('active');
  }
  function closeCart() {
    var drawer = getCartDrawer();
    var overlay = document.querySelector('.mm-fullscreen-bg');
    if (!drawer) return;
    drawer.classList.remove('show');
    if (overlay) overlay.classList.remove('active');
  }

  /* Runs whenever .show changes, whoever changed it. */
  function onCartToggle() {
    var drawer = getCartDrawer();
    var open = cartIsOpen();
    if (!drawer || open === cartWasOpen) return;
    cartWasOpen = open;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('.shopping-cart a.cart-count').forEach(function (link) {
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      clearTimeout(cartCloseTimer);
      document.body.classList.add('hidden', 'sf-cart-open');
      if (!drawer.contains(document.activeElement)) cartReturnFocus = document.activeElement;
      var closeButton = drawer.querySelector('[data-sf-cart-close]');
      (closeButton || drawer).focus({ preventScroll: true });
      /* Show the current cart even if it changed elsewhere (another tab, the cart page). */
      if (Date.now() - cartRenderedAt > 1500) refreshCart();
    } else {
      document.body.classList.remove('hidden');
      cartNotice = '';
      cartCloseTimer = setTimeout(function () { document.body.classList.remove('sf-cart-open'); }, 350);
      if (cartReturnFocus && document.contains(cartReturnFocus) && (drawer.contains(document.activeElement) || document.activeElement === document.body)) {
        cartReturnFocus.focus({ preventScroll: true });
      }
      cartReturnFocus = null;
    }
  }

  function bindCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.sfObserved) return;
    drawer.sfObserved = true;
    cartWasOpen = false;
    cartViews().forEach(function (view) {
      var inner = view.root.querySelector('[data-sf-cart-inner]');
      view.root.sfLastHtml = inner ? inner.outerHTML : '';
    });
    new MutationObserver(onCartToggle).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('.shopping-cart a.cart-count').forEach(function (link) {
      link.setAttribute('aria-controls', drawer.id);
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-expanded', 'false');
    });
    onCartToggle();
  }
  bindCartDrawer();

  function cartBusy(delta) {
    cartPending = Math.max(0, cartPending + delta);
    cartViews().forEach(function (view) {
      view.root.classList.toggle('is-busy', cartPending > 0);
      view.root.setAttribute('aria-busy', cartPending > 0 ? 'true' : 'false');
    });
  }

  /* Shopify's limit messages on add: "Only N items were added to your cart due to availability." counts a
     single cart line, and Bundler spreads one product over several lines, so N is wrong ("6" when 50 were
     added); "The maximum quantity of this item is already in your cart." doesn't say how many. Both are
     replaced with the real number of that product now in the cart (the variant last sent to add). */
  var cartLastAddVariant = null;
  var cartNotice = '';
  function cartErrorText(message, fresh) {
    if (!/were added to your cart due to availability|maximum quantity of this item is already in your cart/i.test(message || '')) return message;
    var inCart = 0;
    if (fresh && cartLastAddVariant) {
      fresh.querySelectorAll('[data-sf-line][data-sf-variant="' + cartLastAddVariant + '"] [data-sf-qty-input]').forEach(function (input) {
        inCart += parseInt(input.defaultValue, 10) || 0;
      });
    }
    if (inCart > 0) return fillMessage(cartText('max-reached', 'Your cart now has the most we can sell of this item ([count]).'), { count: inCart });
    return cartText('stock-added', 'We added all the available stock to your cart.');
  }
  /* Remember which variant an add-to-cart is for (product page, quick view, product cards). */
  function rememberAddVariant(form) {
    var field = form && form.querySelector('[name="id"]');
    if (field && field.value) cartLastAddVariant = field.value;
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ajax-spin-cart, #buyNow, .addtocartqv');
    if (button) {
      cartNotice = '';
      rememberAddVariant(button.closest('form'));
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.closest('[data-sf-atc-form]')) cartNotice = '';
    rememberAddVariant(event.target.closest('form'));
  }, true);

  /* Swap in freshly rendered sections ({ sectionId: html }) for every cart view, then sync the header badge. */
  function renderCart(sections, options) {
    if (!sections) return;
    options = options || {};
    cartRenderedAt = Date.now();
    var count = null;
    cartViews().forEach(function (view) {
      var viewCount = renderCartView(view, sections[view.section], options);
      if (viewCount !== null) count = viewCount;
    });
    /* Header badge(s); the "is-empty" state follows through the badge observer above. */
    if (count === null) return;
    var drawer = getCartDrawer();
    document.querySelectorAll('.bigcounter').forEach(function (badge) {
      if (!drawer || !drawer.contains(badge)) badge.textContent = count;
    });
  }

  /* One view: keep focus (and a note being typed), scroll position, and show an optional error. Returns the item count. */
  function renderCartView(view, sectionHtml, options) {
    var root = view.root;
    var current = root.querySelector('[data-sf-cart-inner]');
    if (!current || !sectionHtml) return null;
    var fresh = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('[data-sf-cart-inner]');
    if (!fresh) return null;
    var count = fresh.getAttribute('data-sf-cart-count');

    /* Same cart as on screen (e.g. the refresh on open): keep the DOM, just reset line states and inputs. */
    if (fresh.outerHTML === root.sfLastHtml && !options.error) {
      current.querySelectorAll('.is-updating').forEach(function (el) { el.classList.remove('is-updating'); });
      current.querySelectorAll('[data-sf-qty-input]').forEach(function (input) {
        if (input !== document.activeElement) input.value = input.defaultValue;
      });
      return count;
    }
    root.sfLastHtml = fresh.outerHTML;

    var active = document.activeElement;
    var hadFocus = !!active && current.contains(active);
    var focusId = hadFocus ? active.getAttribute('data-sf-focus') : null;
    var typing = hadFocus && active.tagName === 'TEXTAREA' ? { value: active.value, start: active.selectionStart, end: active.selectionEnd } : null;
    var oldBody = current.querySelector('.sf-cart__body');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;

    current.replaceWith(fresh);

    var newBody = fresh.querySelector('.sf-cart__body');
    if (newBody) newBody.scrollTop = scrollTop;
    if (hadFocus) {
      var target = focusId && fresh.querySelector('[data-sf-focus="' + focusId.replace(/["\\]/g, '\\$&') + '"]');
      (target || fresh.querySelector('[data-sf-cart-close]') || fresh).focus({ preventScroll: true });
      if (target && typing) {
        target.value = typing.value;
        target.setSelectionRange(typing.start, typing.end);
      }
    }

    var line = options.error && options.line && fresh.querySelector(cartLineSelector(options.line));
    if (line) {
      var lineBox = line.querySelector('[data-sf-line-error]');
      if (lineBox) {
        lineBox.textContent = cartErrorText(options.error, fresh);
        lineBox.hidden = false;
      }
    } else {
      /* A cart message stays through the re-renders that follow (Bundler rewrites the cart a moment after
         every add) until the drawer is closed or the cart is changed again. */
      if (options.error) cartNotice = cartErrorText(options.error, fresh);
      var box = fresh.querySelector('[data-sf-cart-error]');
      if (box && cartNotice) {
        box.textContent = cartNotice;
        box.hidden = false;
      }
    }

    var status = root.querySelector('[data-sf-cart-status]');
    var subtotal = fresh.querySelector('[data-sf-cart-subtotal]');
    if (status && options.announce !== false) {
      status.textContent = (options.error && cartErrorText(options.error, fresh)) || (cartText('updated', 'Cart updated') + (subtotal ? ': ' + subtotal.textContent.trim() : ''));
    }
    return count;
  }

  /* Cart requests (add, change, refresh) run one at a time, in order. */
  function cartEnqueue(run) {
    var request = cartQueue.then(run, run);
    cartQueue = request.catch(function () {});
    return request;
  }

  /* The Bundler quantity-break app answers every cart change by reading the cart and then rewriting each line
     by position (change.js { line, quantity }) with the quantity it read, and it reuses a cart read for up to
     1.5s. A change sent while it does that is overwritten, units get added twice, and keys on screen go stale
     ("no valid id or line parameter"). So cart changes wait until no cart request is running and the cart
     has been quiet for longer than that cache. Every cart request on the page (fetch and XHR, from any
     script) is tracked; this file's own reads of /cart.js pass sfQuiet so they don't count. */
  var CART_QUIET_MS = 1600;
  var cartActivity = { inflight: 0, last: 0 };
  function isCartUrl(url) {
    return /\/cart(\.js|\/|\?|$)/.test(String(url || '').replace(/^https?:\/\/[^/]+/, ''));
  }
  function cartActivityStart() {
    cartActivity.inflight++;
    cartActivity.last = Date.now();
  }
  function cartActivityEnd() {
    cartActivity.inflight = Math.max(0, cartActivity.inflight - 1);
    cartActivity.last = Date.now();
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
      if (!isCartUrl(url) || (init && init.sfQuiet)) return nativeFetch.apply(window, arguments);
      cartActivityStart();
      var request = nativeFetch.apply(window, arguments);
      request.then(cartActivityEnd, cartActivityEnd);
      return request;
    };
  }
  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.sfCartRequest = isCartUrl(url);
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.sfCartRequest) {
        cartActivityStart();
        this.addEventListener('loadend', cartActivityEnd);
      }
      return nativeSend.apply(this, arguments);
    };
  }
  function cartSettled() {
    var started = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        var quiet = cartActivity.inflight === 0 && Date.now() - cartActivity.last >= CART_QUIET_MS;
        if (quiet || Date.now() - started > 8000) resolve();
        else setTimeout(check, 100);
      })();
    });
  }

  /* POST to the Cart API once the cart is settled; resolves with the JSON body or rejects with an Error
     carrying status + message. body can be a function that builds it (a promise) at send time, from the
     cart as it is then; when it returns nothing, nothing is sent and this resolves with null. */
  function cartSend(path, body) {
    cartBusy(1);
    return cartEnqueue(function () {
      return cartSettled().then(function () {
        return typeof body === 'function' ? body() : body;
      }).then(function (payload) {
        if (!payload) return null;
        var isForm = payload instanceof FormData;
        var headers = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
        if (!isForm) headers['Content-Type'] = 'application/json';
        return fetch(cartRoot() + path, {
          method: 'POST',
          headers: headers,
          body: isForm ? payload : JSON.stringify(payload)
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) {
              var error = new Error(data.description || data.message || '');
              error.status = response.status;
              throw error;
            }
            return data;
          });
        });
      });
    }).finally(function () {
      cartBusy(-1);
    });
  }

  /* Re-render from the current Shopify cart without changing it. Errors are always shown. */
  function refreshCart(options) {
    if (!cartViews().length || !window.fetch) return Promise.resolve();
    var id = ++cartRequestId;
    return cartEnqueue(function () {
      return fetch(cartRoot() + '?sections=' + encodeURIComponent(cartSectionIds()), { cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (sections) {
          if ((options && options.error) || cartShouldRender(id)) renderCart(sections, options);
        });
    }).catch(function () {});
  }

  /* What a row looked like when it was rendered. A row can stand for several cart lines (see sf-cart-groups). */
  function cartLineMeta(line) {
    return {
      key: line.getAttribute('data-sf-line'),
      sig: line.getAttribute('data-sf-sig'),
      variant: Number(line.getAttribute('data-sf-variant')),
      max: line.hasAttribute('data-sf-max') ? parseInt(line.getAttribute('data-sf-max'), 10) || 0 : null
    };
  }

  /* Keep a row within the variant's stock (data-sf-max, only when stock is tracked and overselling is off):
     Shopify's cart update does not check stock, so the cart could otherwise hold more than can be bought.
     Shows "Only N available." on the row when the asked quantity is cut. */
  function cartClampToStock(line, quantity) {
    var meta = cartLineMeta(line);
    var box = line.querySelector('[data-sf-line-error]');
    if (meta.max !== null && quantity > meta.max) {
      if (box) {
        var order = line.getAttribute('data-sf-max-kind') === 'order';
        box.textContent = fillMessage(order ? cartText('max-order', 'You can order up to [count] of this item.') : cartText('max-stock', 'Only [count] available.'), { count: meta.max });
        box.hidden = false;
      }
      return meta.max;
    }
    if (box) box.hidden = true;
    return quantity;
  }

  /* Same as snippets/sf-cart-line-sig.liquid: variant, selling plan and visible properties. */
  function cartGroupSig(item) {
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var sig = item.variant_id + '/' + (plan ? plan.id : '');
    Object.keys(item.properties || {}).forEach(function (name) {
      var value = item.properties[name];
      if (name.charAt(0) !== '_' && value !== null && String(value).trim() !== '') sig += '/' + name + '=' + value;
    });
    return sig;
  }

  /* Set the total quantity of a row (by its signature, whatever lines and keys it has by then). The cart is
     read and the change sent in one step once the cart is settled, using the latest quantity asked for on
     that row, so quick clicks end up as one change. Extra units go on the last line, removed units come off
     the last lines first; Bundler re-tiers them afterwards. */
  var cartLineTargets = {};
  var cartLineJobs = {};
  function changeCartLine(meta, quantity) {
    cartNotice = '';
    var sig = meta.sig;
    var id = ++cartRequestId;
    cartLineTargets[sig] = quantity;
    cartLineJobs[sig] = (cartLineJobs[sig] || 0) + 1;
    document.querySelectorAll(cartLineSelector(meta.key)).forEach(function (line) {
      line.classList.add('is-updating');
    });

    function buildUpdate() {
      return fetch(cartRoot() + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' }, sfQuiet: true })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          /* Sent as a quantity per line position, not by key: Bundler's split lines carry identical
             properties, so they share one key and a key update would only change the first of them. */
          var target = cartLineTargets[sig];
          var updates = cart.items.map(function (item) { return item.quantity; });
          var positions = [];
          var otherRows = 0; /* same variant on other rows (e.g. different properties) share the stock */
          cart.items.forEach(function (item, index) {
            if (cartGroupSig(item) === sig) positions.push(index);
            else if (item.variant_id === meta.variant) otherRows += item.quantity;
          });
          if (meta.max !== null) target = Math.min(target, Math.max(0, meta.max - otherRows));
          var current = positions.reduce(function (sum, index) { return sum + updates[index]; }, 0);
          if (!positions.length || current === target) return null;
          if (target > current) {
            updates[positions[positions.length - 1]] += target - current;
          } else {
            var remove = current - target;
            for (var i = positions.length - 1; i >= 0 && remove > 0; i--) {
              var take = Math.min(remove, updates[positions[i]]);
              updates[positions[i]] -= take;
              remove -= take;
            }
          }
          return { updates: updates, sections: cartSectionIds(), sections_url: window.location.pathname };
        });
    }
    function send(retried) {
      return cartSend('cart/update.js', buildUpdate).catch(function (error) {
        /* 400/404: the cart changed in the moment between reading it and sending; read it again. */
        if (!retried && (error.status === 400 || error.status === 404)) return send(true);
        throw error;
      });
    }

    return send(false)
      .then(function (result) {
        var lastJob = cartLineJobs[sig] === 1 && !Object.keys(cartLineTimers).length;
        if (result && (cartShouldRender(id) || lastJob)) renderCart(result.sections);
        else if (!result && lastJob) return refreshCart({ announce: false });
      })
      .catch(function (error) {
        return refreshCart({ error: error.message || cartText('error', 'Something went wrong. Please try again.'), line: meta.key });
      })
      .finally(function () {
        if (--cartLineJobs[sig] <= 0) {
          delete cartLineJobs[sig];
          delete cartLineTargets[sig];
        }
      });
  }

  /* Quick +/- clicks on one row are sent as one request. Keyed by signature: the row's line key changes
     whenever the app rewrites it, the signature does not. */
  function queueCartLine(meta, quantity, delay) {
    clearTimeout(cartLineTimers[meta.sig]);
    cartLineTimers[meta.sig] = setTimeout(function () {
      delete cartLineTimers[meta.sig];
      changeCartLine(meta, quantity);
    }, delay);
  }

  /* Other scripts (Hyper's cart page, apps) can change the cart too: re-render shortly after any cart
     change request that finished on this page. Unchanged content is not re-rendered (see renderCart). */
  var cartForeignTimer = null;
  function scheduleForeignRefresh() {
    clearTimeout(cartForeignTimer);
    cartForeignTimer = setTimeout(function () {
      var active = document.activeElement;
      var editing = active && active.matches && active.matches('[data-sf-qty-input]') && active.value !== active.defaultValue;
      if (cartPending > 0 || editing || Object.keys(cartLineTimers).length) {
        scheduleForeignRefresh();
        return;
      }
      refreshCart({ announce: false });
    }, 400);
  }
  if (window.PerformanceObserver && cartViews().length) {
    try {
      new PerformanceObserver(function (list) {
        var changed = list.getEntries().some(function (entry) {
          return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name);
        });
        if (changed) scheduleForeignRefresh();
      }).observe({ type: 'resource' });
    } catch (e) { /* older browsers: the drawer still refreshes on open */ }
  }

  document.addEventListener('click', function (event) {
    var drawer = getCartDrawer();
    if (drawer) {
      /* Header cart icon opens the drawer (its /cart link is the no-JS fallback). */
      if (event.target.closest('.shopping-cart a.cart-count')) {
        event.preventDefault();
        openCart();
        return;
      }
      if (event.target.closest('[data-sf-cart-close]') || (cartIsOpen() && event.target.closest('.mm-fullscreen-bg'))) {
        closeCart();
        return;
      }
    }

    /* Quantity / remove, in the mini cart or on the cart page */
    if (!event.target.closest('[data-sf-cart], [data-sf-cart-page]') || !window.fetch) return;
    var line = event.target.closest('[data-sf-line]');
    if (!line) return;
    var meta = cartLineMeta(line);
    var step = event.target.closest('[data-sf-qty-step]');
    if (step) {
      var input = line.querySelector('[data-sf-qty-input]');
      var shown = parseInt(input.value, 10) || 0;
      var next = cartClampToStock(line, Math.max(0, shown + parseInt(step.getAttribute('data-sf-qty-step'), 10)));
      if (next === shown) return; /* already at the stock limit */
      input.value = next;
      queueCartLine(meta, next, 350);
      return;
    }
    if (event.target.closest('[data-sf-remove]')) {
      event.preventDefault(); /* cart page: the link is the no-JS fallback */
      clearTimeout(cartLineTimers[meta.sig]);
      delete cartLineTimers[meta.sig];
      changeCartLine(meta, 0);
    }
  });

  /* Typed quantities: on change (blur) or Enter. */
  function commitTypedQuantity(input) {
    var line = input.closest('[data-sf-line]');
    if (!line) return;
    var quantity = cartClampToStock(line, Math.max(0, parseInt(input.value, 10) || 0));
    input.value = quantity;
    if (String(quantity) === input.defaultValue) return;
    queueCartLine(cartLineMeta(line), quantity, 0);
  }
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-sf-cart] [data-sf-qty-input], [data-sf-cart-page] [data-sf-qty-input]');
    if (input && window.fetch) commitTypedQuantity(input);
  });

  /* Cart page: Enter in a quantity updates that line (instead of submitting the whole form). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !window.fetch) return;
    var input = event.target.closest('[data-sf-cart-page] [data-sf-qty-input]');
    if (!input) return;
    event.preventDefault();
    commitTypedQuantity(input);
  });

  /* Cart page: save the order note while typing (it is also sent with Update cart / Checkout). */
  var cartNoteTimer = null;
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-sf-cart-note]');
    if (!note || !window.fetch) return;
    clearTimeout(cartNoteTimer);
    cartNoteTimer = setTimeout(function () {
      cartEnqueue(function () {
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }).catch(function () {});
    }, 600);
  });

  document.addEventListener('keydown', function (event) {
    var drawer = getCartDrawer();
    if (!drawer || !cartIsOpen()) return;
    if (event.key === 'Escape') {
      closeCart();
      return;
    }
    if (event.key === 'Enter' && event.target.closest('[data-sf-qty-input]')) {
      event.preventDefault();
      commitTypedQuantity(event.target);
      return;
    }
    if (event.key !== 'Tab') return;
    /* Keep keyboard focus inside the open drawer. */
    var focusable = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([disabled])'),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* Product page quantity ([data-sf-qty], snippets/product-quantity.liquid): required, whole number, 1 or more,
     and within the stock left after what the cart already holds.
     Only digits can be typed; Add to cart, Buy now and Enter are stopped with a message until it is valid.
     Capture phase, so this runs before Hyper's jQuery click handler and the inline Buy now handler. */
  function qtyErrorBox(input) {
    var form = input.closest('form');
    return form ? form.querySelector('[data-sf-qty-error]') : null;
  }
  function fillMessage(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, name) {
      return name in values ? values[name] : match;
    });
  }
  /* Units of a variant already in the cart, from the mini cart rows (each row shows its total quantity). */
  function cartQuantityOf(variantId) {
    var drawer = getCartDrawer();
    if (!drawer || !variantId) return 0;
    var total = 0;
    drawer.querySelectorAll('[data-sf-line][data-sf-variant="' + variantId + '"] [data-sf-qty-input]').forEach(function (input) {
      total += parseInt(input.defaultValue, 10) || 0;
    });
    return total;
  }
  /* Stock limit of the selected variant (data-sf-max on its <option>; none when stock isn't tracked). */
  function selectedVariantStock(form) {
    var select = form && form.querySelector('[name="id"]');
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    if (!option || !option.hasAttribute('data-sf-max')) return null;
    return { id: option.value, max: parseInt(option.getAttribute('data-sf-max'), 10) || 0, kind: option.getAttribute('data-sf-max-kind') };
  }
  function checkQuantity(input, show) {
    var value = input.value.trim();
    var message = '';
    if (value === '') message = input.getAttribute('data-sf-msg-required') || 'Please enter a quantity.';
    else if (!/^\d+$/.test(value) || parseInt(value, 10) < 1) message = input.getAttribute('data-sf-msg-min') || 'Please enter a quantity of 1 or more.';
    else {
      var stock = selectedVariantStock(input.closest('form'));
      if (stock) {
        var inCart = cartQuantityOf(stock.id);
        var remaining = Math.max(0, stock.max - inCart);
        var values = { count: stock.max, in_cart: inCart, remaining: remaining };
        if (parseInt(value, 10) > remaining) {
          /* "order": the per-product maximum (Theme settings), "stock": what is left in stock */
          var order = stock.kind === 'order';
          if (remaining === 0 && inCart > 0) message = fillMessage(input.getAttribute(order ? 'data-sf-msg-limit-full' : 'data-sf-msg-all-in-cart'), values);
          else if (inCart > 0) message = fillMessage(input.getAttribute(order ? 'data-sf-msg-limit-in-cart' : 'data-sf-msg-max-in-cart'), values);
          else message = fillMessage(input.getAttribute(order ? 'data-sf-msg-limit' : 'data-sf-msg-max'), values);
        }
      }
    }
    var box = qtyErrorBox(input);
    if (message) {
      input.setAttribute('aria-invalid', 'true');
      if (show && box) {
        box.textContent = message;
        box.hidden = false;
      }
    } else {
      input.removeAttribute('aria-invalid');
      if (box) {
        box.hidden = true;
        box.textContent = '';
      }
    }
    return !message;
  }
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-sf-qty]');
    if (!input) return;
    var digits = input.value.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
    if (digits !== input.value) input.value = digits;
    /* While a message is showing, update it as the shopper types (and clear it once valid). */
    var box = qtyErrorBox(input);
    checkQuantity(input, !!box && !box.hidden);
  });
  document.addEventListener('focusout', function (event) {
    var input = event.target.closest('[data-sf-qty]');
    if (input) checkQuantity(input, true);
  });
  function blockInvalidQuantity(event, form) {
    var input = form && form.querySelector('[data-sf-qty]');
    if (!input || checkQuantity(input, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.focus();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.sf-pdp .ajax-spin-cart, .sf-pdp #buyNow');
    if (!button) return;
    blockInvalidQuantity(event, button.closest('form'));
  }, true);
  document.addEventListener('submit', function (event) {
    blockInvalidQuantity(event, event.target.closest('form'));
  }, true);

  /* Subscription option ([data-sf-sub], snippets/sf-subscription.liquid): the hidden selling_plan field is
     enabled only for "Subscribe & save" and holds the chosen plan; both prices follow the selected variant. */
  function syncSubscription(box) {
    var form = box.closest('form');
    var variantField = form && form.querySelector('[name="id"]');
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-sf-sub-prices]').textContent); } catch (e) {}
    var variant = prices[variantField && variantField.value] || { plans: {} };
    var mode = box.querySelector('[data-sf-sub-mode]:checked');
    var subscribe = mode ? mode.value === 'plan' : true;
    var plan = box.querySelector('[data-sf-sub-plan]');
    var input = box.querySelector('[data-sf-sub-input]');
    var oncePrice = box.querySelector('[data-sf-sub-once-price]');
    var planPrice = box.querySelector('[data-sf-sub-plan-price]');

    input.value = plan.value;
    input.disabled = !subscribe;
    box.classList.toggle('is-subscribing', subscribe);
    if (oncePrice && variant.once) oncePrice.textContent = variant.once;
    if (planPrice && variant.plans[plan.value]) planPrice.textContent = variant.plans[plan.value];
  }
  function initSubscriptions(root) {
    (root || document).querySelectorAll('[data-sf-sub]').forEach(syncSubscription);
  }
  document.addEventListener('change', function (event) {
    var box = event.target.closest('[data-sf-sub]');
    if (box) return syncSubscription(box);
    /* Variant change: Hyper's option selectors update the [name="id"] select in their own change handler. */
    var form = event.target.closest('form');
    box = form && form.querySelector('[data-sf-sub]');
    if (box) setTimeout(function () { syncSubscription(box); }, 0);
  });
  document.addEventListener('DOMContentLoaded', function () { initSubscriptions(); });
  document.addEventListener('shopify:section:load', function (event) { initSubscriptions(event.target); });

  /* Product cards ([data-sf-atc-form]): add without leaving the page, render the drawer from the same
     response and open it. Shopify errors (e.g. not enough stock) are shown in the drawer; any other
     failure falls back to a normal form submit (cart page). */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-sf-atc-form]');
    if (!form || !window.fetch || !getCartDrawer()) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    /* Not using button.disabled: Hyper styles button[disabled] grey with !important. */
    if (button && button.classList.contains('is-loading')) return;
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }
    var body = new FormData(form);
    body.append('sections', cartSectionIds());
    body.append('sections_url', window.location.pathname);
    var id = ++cartRequestId;

    cartSend('cart/add.js', body)
      .then(function (item) {
        if (cartShouldRender(id)) renderCart(item.sections);
        openCart();
      })
      .catch(function (error) {
        if (error.status && error.message) {
          return refreshCart({ error: error.message }).then(openCart);
        }
        form.submit();
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      });
  });

  /* Hyper's own add buttons (product page, quick view, grid items) go through api.jquery.js; route their
     results into this drawer. Set after all deferred scripts (cart.api.js loads after this file). */
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Shopify || !getCartDrawer()) return;
    Shopify.onItemAdded = function () {
      refreshCart().then(openCart);
    };
    var hyperCartUpdate = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function (cart) {
      if (typeof hyperCartUpdate === 'function') hyperCartUpdate(cart);
      refreshCart();
    };
    Shopify.onError = function (xhr) {
      var message = '';
      try { message = JSON.parse(xhr.responseText).description || ''; } catch (e) {}
      refreshCart({ error: message || cartText('error', 'Something went wrong. Please try again.') }).then(openCart);
    };
  });

  /* Back/forward cache: the cart may have changed on another page (e.g. checkout). */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart({ announce: false });
  });

  /* Theme editor re-renders the header section (and the drawer with it). */
  document.addEventListener('shopify:section:load', bindCartDrawer);

  /* Hero slider (Swiper 8, bundled by Hyper). Only the image slides; the caption is shared. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(hero) {
    var media = hero.querySelector('.sf-hero__media');
    if (!media || media.swiper || typeof Swiper === 'undefined') return;
    if (media.querySelectorAll('.swiper-slide').length < 2) return;

    var autoplay = hero.dataset.autoplay === 'true' && !reduceMotion;
    var dots = hero.querySelector('.sf-hero__dots');

    new Swiper(media, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: reduceMotion ? 0 : 900,
      allowTouchMove: true,
      autoplay: autoplay ? {
        delay: parseInt(hero.dataset.speed, 10) || 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      pagination: dots ? {
        el: dots,
        clickable: true,
        bulletElement: 'button',
        bulletClass: 'sf-hero__dot',
        bulletActiveClass: 'is-active'
      } : false,
      a11y: { enabled: true }
    });
  }

  function destroyHero(hero) {
    var media = hero && hero.querySelector('.sf-hero__media');
    if (media && media.swiper) media.swiper.destroy(true, true);
  }

  document.querySelectorAll('[data-sf-hero]').forEach(initHero);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sf-hero]').forEach(initHero);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-sf-hero]').forEach(destroyHero);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var hero = event.target.closest('[data-sf-hero]');
    var media = hero && hero.querySelector('.sf-hero__media');
    if (!media || !media.swiper) return;
    var slides = Array.prototype.slice.call(media.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
    var index = slides.indexOf(event.target);
    if (index > -1) {
      media.swiper.autoplay && media.swiper.autoplay.stop();
      media.swiper.slideToLoop(index);
    }
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var hero = event.target.closest('[data-sf-hero]');
    var media = hero && hero.querySelector('.sf-hero__media');
    if (media && media.swiper && hero.dataset.autoplay === 'true' && !reduceMotion) media.swiper.autoplay.start();
  });
})();
